var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"productDetailsWrapper"}},[_c('media-only',{attrs:{"desktop":""}},[(_vm.uspBannerVisible)?_c('USPBanner'):_vm._e()],1),_vm._v(" "),_c(_vm.component,_vm._b({tag:"component"},'component',{
            product: _vm.product,
            marker: _vm.marker,
            extraServicesAndInfos: _vm.extraServicesAndInfos,
            relatedProducts: _vm.relatedProducts,
            hotelProducts: _vm.hotelProducts,
            teaser: _vm.teaser,
            productDetails: _vm.productDetails,
            hotelDetails: _vm.hotelDetails,
            isOtherProduct: _vm.isOtherProduct
        },false)),_vm._v(" "),(_vm.$store.state.globalMeta.newsletterFormEnabled)?_c('ExitIntentNewsletter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }